import { Action } from "../context/actions";
import { UserStateInterface } from "../interfaces/user/user-state-interface";
import { StandardHandler } from "./standard-handler";

export const reducer = (state: UserStateInterface, action: Action) => {
  switch (action.type) {
    case "CLEAR_STATE":
      return {
        ...state,
        user: null,
        data: null,
        openUrl: null,
        openReport: null,
        openModel: null,
        openPdf: null,
        projectTeam: null,
        modelViewerData: null,
        openReportDescription: null,
        decision: null,
        response: action.response,
      };
    case "CLEAR_DATA":
      return {
        ...state,
        data: null,
      };
    case "UPDATE_USER":
      return {
        ...state,
        user: action.payload,
        response: action.response,
      };
    case "LOGOUT":
      return {
        ...state,
        data: action.payload,
      };
    case "AUTHENTICATE":
      return { ...state, data: action.payload };
    case "REGISTER":
      return { ...state, data: action.payload };
    case "SIGNUP":
      return {
        ...state,
        response: action.response,
      };
    case "CREATE_EXTERNAL_CONNECTION":
      return { ...state, data: action.payload };
    case "EDIT_PROFILE":
      return { ...state, data: action.payload };
    case "RECOVER_PASSWORD":
      return { ...state, data: action.payload };
    case "RETRIEVE_USER_SUBSCRIPTION":
      return { ...state, data: action.payload };
    case "RETRIEVE_USER":
      return { ...state, data: action.payload };
    case "OPEN_URL":
      return { ...state, openUrl: action.payload, response: action.response };
    // PROJECT DISPATCHER
    case "CREATE_PROJECT":
      return { ...state, data: action.payload };
    case "DELETE_PROJECT":
      return { ...state, data: action.payload };
    case "DOWNLOAD_PROJECT":
      return { ...state, data: action.payload };
    case "EDIT_PROJECT":
      return { ...state, data: action.payload };
    case "RETRIEVE_PROJECT_TEAM":
      return { ...state, data: action.payload };
    case "OPEN_PROJECT_TEAM":
      return {
        ...state,
        projectTeam: action.payload,
        response: action.response,
      };
    case "CLOSE_PROJECT_TEAM":
      return {
        ...state,
        projectTeam: null,
      };
    case "EDIT_PROJECT_TEAM":
      return {
        ...state,
        data: action.payload,
      };
    // FORGE DISPATCHER
    case "CREATE_FORGE":
      return { ...state, data: action.payload };
    case "EDIT_FORGE":
      return { ...state, data: action.payload };
    case "DELETE_FORGE":
      return { ...state, data: action.payload };
    case "RUN_FORGE":
      return { ...state, data: action.payload };
    // FOLDER DISPATCHER
    case "CREATE_FOLDER":
      return { ...state, data: action.payload };
    case "DELETE_FOLDER":
      return { ...state, data: action.payload };
    case "EDIT_FOLDER":
      return { ...state, data: action.payload };
    case "DOWNLOAD_FOLDER":
      return { ...state, data: action.payload };
    // MODEL DISPATCHER
    case "UPLOAD_FILE":
      return { ...state, data: action.payload };
    case "DELETE_FILE":
      return { ...state, data: action.payload };
    case "DOWNLOAD_FILE":
      return { ...state, data: action.payload };
    case "RETRIEVE_MODEL":
      return { ...state, data: action.payload };
    case "RETRIEVE_PDF":
      return { ...state, data: action.payload };
    case "STORE_MODEL_FRAGMENTS":
      return { ...state, data: action.payload };
    case "SHARE_PROJECT":
      return { ...state, data: action.payload };
    case "DELETE_MODEL":
      return { ...state, data: action.payload };
    case "OPEN_MODEL":
      return {
        ...state,
        openModel: action.payload,
        response: action.response,
      };
    case "OPEN_PDF":
      return {
        ...state,
        openPdf: action.payload,
        response: action.response,
      };
    case "CLOSE_PDF":
      return { ...state, openPdf: null };
    case "DOWNLOAD_REPORT":
      return { ...state, data: action.payload };
    case "DELETE_REPORT":
      return { ...state, data: action.payload };
    case "RETRIEVE_REPORT":
      return { ...state, data: action.payload };
    case "RETRIEVE_REPORT_DESCRIPTION":
      return { ...state, data: action.payload };
    case "OPEN_REPORT":
      return {
        ...state,
        openReport: action.payload,
        response: action.response,
      };
    case "CLOSE_REPORT":
      return {
        ...state,
        openReport: null,
      };
    case "OPEN_REPORT_DESCRIPTION":
      return {
        ...state,
        openReportDescription: action.payload,
        response: action.response,
      };
    case "CLOSE_REPORT_DESCRIPTION":
      return {
        ...state,
        openReportDescription: null,
      };
    case "SUBMIT_REPORT_DESCRIPTION":
      return {
        ...state,
        data: action.payload,
      };
    case "SUBMIT_REPORT_ELEMENT_NOTE":
      return {
        ...state,
        data: action.payload,
      };
    case "FILTER_REPORT":
      return {
        ...state,
        openReport: action.payload,
      };
    // UI DISPATCHER
    case "DECISION":
      return { ...state, decision: action.decision };
    case "RESPONSE":
      return {
        ...state,
        response: action.response,
      };
    case "UPLOAD_PROGRESS":
      return {
        ...state,
        uploadProgress: action.payload,
      };
    case "ARCHIVE_PROGRESS":
      return {
        ...state,
        archiveProgress: action.payload,
      };
    // VIEWPORT DISPATCHER
    // Carries the finished fragments buffer, not a promise. The conversion
    // itself is started from StandardViewport's effect, because a reducer has
    // to stay pure -- and because parking the promise in `data` made
    // CoreHandler read `.type` off it, fall through its switch and raise
    // "Unknown operation type" on every single model open.
    case "CONVERT_MODEL":
      return { ...state, modelConversion: action.payload };
    case "OPEN_FRAGMENTS":
      StandardHandler.OpenModelFragments(state.openModel);
      return state;
    case "CLOSE_STANDARD":
      StandardHandler.Close();
      return { ...state, openModel: null };
    case "HIDE_MODEL_ELEMENT":
      StandardHandler.HideModelElement();
      return state;
    case "UNHIDE_ALL_MODEL_ELEMENTS":
      StandardHandler.UnhideAllModelElements();
      return state;
    case "ISOLATE_MODEL_ELEMENT":
      StandardHandler.IsolateModelElement();
      return state;
    case "SHOW_MODEL_ELEMENT_PROPERTIES":
      StandardHandler.ShowModelElementProperties();
      return state;
    //THROW ERROR
    default:
      throw new Error();
  }
};
